<template>
  <div v-if="schools" class="page has-background-blue with-title">
    <h1 class="page-title has-text-weight-bold has-text-centered is-size-5">{{ section_title }}</h1>
    <div class="container p-4">
      <div class="columns is-multiline is-mobile">
        <generic-mosaic-item v-for="item in schools" :data="item" :key="item.id" @click="openContent(item)"/>
        <div class="column is-12-mobile is-6-tablet is-offset-3-tablet" v-if="emptyResult">
          <div class="no-results">
            No se han encontrado resultados.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericMosaicItem from "@/components/lists/GenericMosaicItem";

export default {
  components: {GenericMosaicItem},
  title: 'Escuelas',
  name: 'SchoolList',
  data: function () {
    return {
      section_title: 'Escuelas',
      schools: null
    }
  },
  computed: {
    emptyResult() {
      if (!this.schools) {
        return false
      }

      return this.schools.length === 0
    },
    userToken() {
      return this.$store.state.token
    }
  },
  methods: {
    async loadContent() {
      try {
        await this.$store.dispatch('initLoading')

        this.schools = await this.$api.school.getList()

        await this.$store.dispatch('finishLoading')
      } catch (error) {
        await this.$store.dispatch('finishLoading')

        await this.handleContentError(error)
      }
    },
    openContent(item) {
      const schoolId = item.id
      this.$router.push(`/schools/${schoolId}`)
    }
  },
  mounted() {
    this.loadContent()
  },
  watch: {
    userToken() {
      this.loadContent()
    }
  }
}
</script>
